import mitt from 'mitt'
import { useEffect, useState } from 'react'

export const bus = mitt()
export const EventBus = {
  FILTER_MOBILE: 'filter-mobile',
  CATEGORY_UID: 'category-uid',
  IS_FILTER_MOBILE: 'is-filter-mobile',
  PRODUCT_DETAIL_MODAL: 'product-detail-modal',
  PRODUCT_DETAIL_LOADING: 'product-detail-loading',
  DEVELOPMENT_MODAL: 'development-modal',
  IS_LOADING_PAGE: 'loading-page',
  NOTI_NOTIFICATION: 'add-noti',
}

export const EventMessage = {
  ADD_TO_CART: 'Sản phẩm đã được thêm vào giỏ hàng',
  CLIPBOARD: 'Đã sao chép',
  CANCEL_ORDER: 'Hủy đơn hàng thành công',
}

export const useEventBus = (eventName: string) => {
  const [eventData, setEventData] = useState(null)
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handler = (data: any) => setEventData(data)
    bus.on(eventName, handler)
    return () => {
      bus.off(eventName, handler)
    }
  }, [eventName])
  return eventData
}
